<div class="row">
    <div [ngClass]="isEdit || isAdd ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #carrierEquipmentGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    [autoSize]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.carrierEquipmentID)"><i class="fas fa-pencil-alt"></i></button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="trailerTypeAbbrev" title="Type Abbrev"></kendo-grid-column>
            <kendo-grid-column field="trailerTypeDescription" title="Type Description"></kendo-grid-column>
            <kendo-grid-column field="equipmentCount" title="Count"></kendo-grid-column>
            <kendo-grid-column field="trailerLength" title="Length"></kendo-grid-column>
            <!--<kendo-grid-column field="notes" title="Notes">
        <ng-template kendoGridCellTemplate let-dataItem>
            {{getActionNotes(dataItem)}}
        </ng-template>
    </kendo-grid-column>-->
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isEdit || isAdd">
        <!-- Edit Customer Action form -->
        <carrier-equipment-form [carrierEquipmentID]="carrierEquipmentID" [carrierID]="carrierID" (onRefresh)="refreshGrid()"></carrier-equipment-form>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
